import { Button, message, Space } from 'antd';
import * as Component from 'components';
import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CompanyInterface } from 'type/companyType';
import { contentProviderService } from '../services/contentProviderService';

const ContentProviderPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams({
    page: '1',
    page_size: '100',
  });

  const columns = [
    {
      title: 'CP',
      dataIndex: 'title',
      key: 'title',
      render: (value: string, record: CompanyInterface): React.ReactNode => (
        <div>
          <div>{record.title}</div>
          {record.title_en && (
            <div style={{ color: '#8c8c8c', fontSize: '12px', marginTop: '2px' }}>
              {record.title_en}
            </div>
          )}
        </div>
      ),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (text: string | null) => text || '-',
    },
    {
      title: 'Slug',
      dataIndex: 'slug',
      key: 'slug',
    },
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country',
    },
    {
      title: 'ODK PIC',
      dataIndex: 'person_in_charge',
      key: 'person_in_charge',
      render: (text: string | null) => text || '-',
    },
    {
      title: 'ODK PIC Email',
      dataIndex: 'person_in_charge_email_address',
      key: 'person_in_charge_email_address',
      render: (text: string | null) => text || '-',
    },
    {
      title: 'Actions',
      key: 'action',
      dataIndex: 'action',
      render: (_text: string, record: CompanyInterface): React.ReactNode => (
        <Space size="middle">
          <Button onClick={() => navigate(`/content-provider/edit/${record.id}`)}>Edit</Button>
          <Button onClick={() => message.info('You do not have permission')}>Delete</Button>
        </Space>
      ),
    },
  ];

  const fetchContentProvider = useCallback(
    async (params: URLSearchParams): Promise<{ data: CompanyInterface[]; count: number }> => {
      const contentList = await contentProviderService.fetchContentProvider(params);
      return { data: contentList.data, count: contentList.count };
    },
    []
  );

  return (
    <Component.BasePageComponent>
      <Component.TableComponent<CompanyInterface>
        name="Content Provider"
        columns={columns}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        actions={{
          onAddClick: () => navigate('/content-provider/add'),
        }}
        dataFetch={fetchContentProvider}
      />
    </Component.BasePageComponent>
  );
};

export default observer(ContentProviderPage);
